import { render } from "./inputChipAux.vue?vue&type=template&id=da57f654&ts=true"
import script from "./inputChipAux.vue?vue&type=script&lang=ts"
export * from "./inputChipAux.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/admin.beepi.cl/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__